<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,8C11,7.72,10.89,7.47,10.71,7.29C10.71,7.29,7.71,4.29,7.71,4.29C7.53,4.11,7.28,4,7,4C6.45,4,6,4.45,6,5C6,5.28,6.11,5.53,6.29,5.71C6.29,5.71,7.59,7,7.59,7C7.59,7,1,7,1,7C0.45,7,0,7.45,0,8C0,8.55,0.45,9,1,9C1,9,7.59,9,7.59,9C7.59,9,6.3,10.29,6.3,10.29C6.11,10.47,6,10.72,6,11C6,11.55,6.45,12,7,12C7.28,12,7.53,11.89,7.71,11.71C7.71,11.71,10.71,8.71,10.71,8.71C10.89,8.53,11,8.28,11,8C11,8,11,8,11,8ZM15,0C15,0,9,0,9,0C8.45,0,8,0.45,8,1C8,1.55,8.45,2,9,2C9,2,14,2,14,2C14,2,14,14,14,14C14,14,9,14,9,14C8.45,14,8,14.45,8,15C8,15.55,8.45,16,9,16C9,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LogIn',
} as DefineComponent
</script>
